import { func, string } from 'prop-types'
import React from 'react'

class ViewLink extends React.PureComponent {
  getClassName = () => {
    let className = `${this.props.view.toLowerCase()}-link view-link`
    if (this.props.selectedView === this.props.view.toLowerCase()) {
      className += ' is-open'
    }
    return className
  }
  handleClick = () => {
    this.props.onClick(this.props.view.toLowerCase())
  }
  render() {
    return (
      <button
        className={this.getClassName()}
        onClick={this.handleClick}
      >
        {this.props.view}
      </button>
    )
  }
}
ViewLink.propTypes = {
  onClick: func.isRequired,
  selectedView: string.isRequired,
  view: string.isRequired,
}

export default ViewLink
